/**
 * Same as claim statuses in ClaimStatus.php
 * NB: Keep in sync
 */
export enum ClaimStatus {
  ACTIVE = 0,
  STOPPED = 1,
  FULFILLED = 2,
  CANCELLED = 3,
  EXPIRED = 4,
  REPLACED = 5,
  NOT_ENFORCEABLE = 6,
};
